export default __webpack_public_path__ + "4951af30d57b97d33a9cab6644b4b8ea.svg";